export const fontSize = {
  title: "14px",
}